import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7dchnd7mw3: FaireBrandEntity = {
  token: "b_7dchnd7mw3",
  type: "brand",
  name: "Adorb Custom Tees",
  avatarUrl:
    "https://cdn.faire.com/fastly/ba16a37fa0c27df19b3ff3021ee2005e92c264f3007409aa44e673d5a8b27138.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3947806f50128729a477b217085a90f3d0067849003d00e5a6e6288cf20828ec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ba16a37fa0c27df19b3ff3021ee2005e92c264f3007409aa44e673d5a8b27138.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3947806f50128729a477b217085a90f3d0067849003d00e5a6e6288cf20828ec.jpeg",
  location: "Aventura, FL, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 21,
  isTopShop: true,
  isInsider: true,
  description:
    "𝗪𝗵𝘆 𝗪𝗲’𝗿𝗲 𝗛𝗲𝗿𝗲: 𝗦𝗽𝗿𝗲𝗮𝗱 𝘁𝗵𝗲 𝗝𝗼𝘆! 🎉\n\nAt Adorb Custom Tees, our mission is to bring joy and self-expression to your wardrobe with adorable, smile-inducing apparel. \n\n𝗛𝗼𝘄 𝗪𝗲 𝗠𝗮𝗸𝗲 𝗠𝗮𝗴𝗶𝗰 𝗛𝗮𝗽𝗽𝗲𝗻: 𝗖𝘂𝘀𝘁𝗼𝗺𝗶𝘇𝗮𝘁𝗶𝗼𝗻 𝗚𝗮𝗹𝗼𝗿𝗲! 🛠️\n\nCustomization is our secret sauce! We create unique pieces that reflect your personality and style. Using top-notch materials and eco-friendly inks, we craft durable, planet-friendly apparel. Even our packaging is recyclable and biodegradable! (Due to the personalized nature of this product, all sales are final. No returns or refunds.)\n\n 𝗪𝗵𝗮𝘁 𝗪𝗲 𝗗𝗼: 𝗖𝗿𝗮𝗳𝘁𝗶𝗻𝗴 𝗛𝗮𝗽𝗽𝗶𝗻𝗲𝘀𝘀 𝗦𝗶𝗻𝗰𝗲 𝟮𝟬𝟮𝟬 👕\n\nBorn from passion in 2020, Adorb Custom Tees is now a bustling Etsy store. Our creative team designs everything from graphic tees to cozy hoodies, perfect for any season. Personalize your gear with names, dates, or quirky jokes to make it uniquely yours. Plus, our custom tees make the best gifts for any occasion! \n\n𝗖𝘂𝘀𝘁𝗼𝗺𝗲𝗿 𝗟𝗼𝘃𝗲: 𝗬𝗼𝘂𝗿 𝗦𝗺𝗶𝗹𝗲, 𝗢𝘂𝗿 𝗣𝗿𝗶𝗼𝗿𝗶𝘁𝘆 💖\n\nYour happiness makes our day! We’re dedicated to top-notch customer service, ensuring a seamless shopping experience. Don’t just take our word for it – our glowing customer reviews say it all!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:58.876Z",
    importedBy: "entity-db-cli",
  },
};
